import React, { useState } from 'react';
import { Button, Card, Tag, Image } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import default_Img from '../../../assets/eol-checker/no_img_avil.png';

const ImageContainer = ({ front_image, back_image, onImageTypeChange }) => {
  const [isFront, setIsFront] = useState(true);

  const frontImage = front_image || default_Img;
  const backImage = back_image || default_Img;

  const cardStyle = {
    width: '250px',
    height: '320px',
    position: 'relative',
    transition: 'all 0.5s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const btnStyle = {
    position: 'absolute',
    top: '7px',
    right: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    zIndex: 2,
  };

  const tagStyle = {
    height: '35px',
    width: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    transition: 'opacity 0.3s ease-in-out',
  };

  // Handle image toggle and notify parent of the change
  const handleImageToggle = () => {
    const newIsFront = !isFront;
    setIsFront(newIsFront);
    // Check if onImageTypeChange is a function before calling it
    if (typeof onImageTypeChange === 'function') {
      onImageTypeChange(newIsFront ? 'Front' : 'Back');
    } else {
      console.error('onImageTypeChange is not a function:', onImageTypeChange);
    }
  };

  return (
    <Card style={cardStyle}>
      <div style={btnStyle}>
        <Tag color={isFront ? 'green' : 'blue'} style={tagStyle}>{isFront ? 'Front' : 'Back'}</Tag>
        <Button size='large' onClick={handleImageToggle}>
          <SwapOutlined />
        </Button>
      </div>
      <Image
        src={isFront ? frontImage : backImage}
        alt={isFront ? 'Front Image' : 'Back Image'}
        width={200}
        height={250}
        style={{ objectFit: 'cover', borderRadius: '5px' }}
      />
    </Card>
  );
};

export default ImageContainer;